<template>
  <div class="titleWrapper fondoTextura paddingText">
    <div>
      <h1 class="title whiteColor">{{$store.getters.title}}</h1>
      <h2 class="subtitle whiteColor">{{$store.getters.subtitle}}</h2>
    </div>
    <div v-if="$route.name === 'editInventoryPage' || $route.name === 'checkInventoryPage' || $route.name === 'inventoryShowPage'">
      <b><div style="color: white; margin-bottom: 10px;">Estado del Inventario</div></b>
      <span
      :class="`font_size_22px inventario_estado inventario_estado_${$store.getters.status}`"
    >{{ $t(inventario_estado[$store.getters.status]) }}</span>
    </div>
    <div class="switchWrapper">
      <translation-switch />
    </div>
  </div>
</template>


<script>
import TranslationSwitch from "@/components/TranslationSwitch.vue";

export default {
  data() {
    return {
      inventario_estado: {
        "0wasApproved": "Aprobado en Borrador",
        "1wasApproved": "Aprobado en Revisión",
        undefined: "No Iniciado",
        0: "Borrador",
        1: "En Revisión",
        2: "Aprobado",
        3: "Importado Borrador",
        4: "Validación de Medioambiente"
      }
    };
  },
  components: {
    TranslationSwitch
  }
};
</script>


<style scoped>
.inventario_estado {
  color: white;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 5px;
  padding-top: 5px;
  border-radius: 3px;
  margin-right: 15px;
}
.inventario_estado_vencido {
  background-color: #b84858;
}
.inventario_estado_undefined {
  background-color: red;
}
.inventario_estado_0 {
  background-color: grey;
}
.inventario_estado_0wasApproved {
  background-color: grey;
}
.inventario_estado_1 {
  background-color: #e4d306;
}
.inventario_estado_1wasApproved {
  background-color: #e4d306;
}
.inventario_estado_2 {
  background-color: #6bc45b;
}
.inventario_estado_3 {
  background-color: orange;
}
.inventario_estado_4 {
  background-color: #e4d306;
}
.titleWrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.fondoTextura {
  background-color: #07758D;
  position: relative;
}
.whiteColor {
  color: white;
}
.title {
  margin: 0;
}
.subtitle {
  font-size: 16px;
  margin: 0;
}
.paddingText {
  padding: 15px 110px;
}
.switchWrapper {
  color: #fff;
  padding: 0 20px;
  display: flex;
  align-items: center;
}
</style>
